// Pack picker ("1 piece / 2 pieces / 3 pieces") on product sections.
// Keeps the radios and the section's quantity box in sync, so Add to cart and the
// Releasit COD form (which reads the visible quantity box) both use the chosen pack.
// Bundle prices themselves come from Shopify automatic discounts on 2+ and 3+ pieces.
(() => {
  const bind = (picker) => {
    const input = document.getElementById(`Quantity-${picker.dataset.section}`);
    if (!input) return;
    const radios = [...picker.querySelectorAll('input[type="radio"]')];
    const select = (qty) => radios.forEach((r) => (r.checked = Number(r.value) === qty));

    picker.addEventListener('change', (event) => {
      if (event.target.type !== 'radio') return;
      input.value = event.target.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('change', () => select(Number(input.value)));
    select(Number(input.value) || 1);
  };

  const init = () =>
    document.querySelectorAll('[data-k-bundle]:not([data-k-ready])').forEach((picker) => {
      picker.dataset.kReady = '';
      bind(picker);
    });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
